import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import { TextInput } from '../../input/text/TextInput'
import { FormField } from '../FormField'
import { useFieldRequired } from '../formSchemaContext'

export type DateTimeFieldProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  labelStyle?: Style
  required?: boolean
  placeholder?: string
}

export const DateTimeField = <T extends FieldValues = FieldValues>({
  name,
  required,
  ...inputProps
}: DateTimeFieldProps<T>) => {
  const fieldRequired = useFieldRequired(name)
  const isRequired = required ?? fieldRequired

  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, onBlur, errorMessage }) => (
        <TextInput
          {...inputProps}
          required={isRequired}
          inputType="datetime-local"
          text={(value as string) ?? ''}
          setText={onChange}
          onBlur={onBlur}
          errorMessage={errorMessage}
        />
      )}
    />
  )
}
